// extracted by mini-css-extract-plugin
export var textInput = "_ir-0";